
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Item } from '@view/a-pedido-cargar/controlador-pedido';
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';


    @Component( {
        name: "Celda",
        props: {},
        components: {
        }
    } )
    export default class Celda extends Vue
    {
        @Prop() Controlador: ControladorInterfaz;
        @Prop() Item: Item;
        public get Articulo() { return this.Item.Articulo; }
        public get MostrarDescuentoPorListaDePrecios()
        {
            return this.Controlador.Configuracion.Opciones.Precios.MostrarDescuentos == 'siempre' || ( this.Controlador.Configuracion.Opciones.Precios.MostrarDescuentos == 'solo-pactados' && this.Articulo.Precio.Modo == 'cliente' );
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            this.Eventos.push( this.Controlador.EdicionPedido.NuevoItem.onEditarItem.subscribe( ( item, index, event ) =>
            {
                if ( item && item.Articulo && item.Articulo.Id == this.Articulo.Id )
                {
                    this.Refrescar();
                }

            } ) );

        }



        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
